import { useMutation } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import type { SupportTicketCreate, SupportTicketResponse } from 'src/shared/schemas/forms/support'

export const useCreateSupportTicket = () => {
  return useMutation({
    mutationFn: async (data: SupportTicketCreate) => {
      const response = await postRequest<SupportTicketResponse>('/users/support', data)
      return response
    },
  })
}
